import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private url: string = API + '/product';

    constructor(private http: HttpClient) { }

    encodeQuery(params: any): string {
        return Object.keys(params).map((key) => {
            return [key, params[key]].map(encodeURIComponent).join('=');
        }).join('&');
    }

    getProducts(params?: any): Observable<any> {
        let query = '';
        if(params) {
            query += '?';
            query += this.encodeQuery(params);
        }
        return this.http.get(`${this.url}${query}`);
    }

    allProducts(): Observable<any> {
        return this.http.get(`${this.url}/all`);
    }

    getProduct(id: number): Observable<any> {
        return this.http.get(`${this.url}/${id}`);
    }

    storeProduct(product: any): Observable<any> {
        return this.http.post(this.url, product);
    }

    updateProduct(id: number, product: any): Observable<any> {
        return this.http.put(`${this.url}/${id}`, product);
    }

    deleteProduct(id: number): Observable<any> {
        return this.http.delete(`${this.url}/${id}`);
    }

    updateUnitPrice(pid: number, bid: number, data: any): Observable<any> {
        return this.http.put(`${this.url}/${pid}/batch/${bid}/unit-price`, data);
    }

    blockBatch(pid: number, bid: number, data: any): Observable<any> {
        return this.http.put(`${this.url}/${pid}/batch/${bid}/block`, data);
    }

    unblockBatch(pid: number, bid: number, data: any): Observable<any> {
        return this.http.put(`${this.url}/${pid}/batch/${bid}/unblock`, data);
    }

    updateInstructions(pid: number, bid: number, data: any): Observable<any> {
        return this.http.put(`${this.url}/${pid}/batch/${bid}/instructions`, data);
    }

    getBatch(pid: number, bid: number): Observable<any> {
        return this.http.get(`${this.url}/${pid}/batch/${bid}`);
    }

    relabel(pid: number, bid: number): Observable<any> {
        return this.http.get(`${this.url}/${pid}/batch/${bid}/relabel`);
    }
}
